// Çevirmen Şeridindeki tek olay kartı.
// Sinyal kartları tıklanabilir, diğerleri statik.

import type { TranslatorEvent } from "../types/api";

interface Props {
  event: TranslatorEvent;
  /** Sinyal kartı tıklandığında çağrılır (sinyal değilse undefined olabilir) */
  onClick?: () => void;
  /** Bu sinyal değerlendirilmiş mi (rozet için) */
  evaluated?: boolean;
}

const KIND_BADGE: Record<TranslatorEvent["kind"], string> = {
  sinyal: "bg-warn-500/15 text-warn-400",
  endeks: "bg-ink-700 text-ink-300",
  islem: "bg-ink-700 text-ink-300",
  anne: "bg-calm-500/15 text-calm-400",
};

const KIND_LABEL: Record<TranslatorEvent["kind"], string> = {
  sinyal: "sinyal",
  endeks: "endeks",
  islem: "işlem",
  anne: "[anne]",
};

export default function CevirmenKart({ event, onClick, evaluated }: Props) {
  const arrowColor = event.direction === "up" ? "text-gain-500" : "text-loss-500";
  const arrow = event.direction === "up" ? "▲" : "▼";
  const isClickable = !!onClick;

  const cardClasses =
    "w-full text-left rounded-xl bg-ink-800 border border-ink-700 px-3 py-2.5 flex items-start gap-3";
  const interactive =
    " hover:border-accent-500/60 hover:bg-ink-700/50 transition group";

  const Content = (
    <>
      <span
        className={`lane-accent self-stretch rounded-full ${
          isClickable ? "" : "opacity-50"
        }`}
      />
      <div className="grow min-w-0">
        <div className="flex items-center gap-2">
          <span className="fon-dili text-ink-200 text-[13px]">
            {event.fonDili}
          </span>
          <span className={arrowColor} aria-hidden="true">
            {arrow}
          </span>
          <span
            className={`ml-auto text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded font-medium ${
              KIND_BADGE[event.kind]
            }`}
          >
            {KIND_LABEL[event.kind]}
          </span>
        </div>
        <p className="hedef-dili text-ink-100 text-sm mt-1 leading-snug">
          {event.hedefDili}
        </p>
        <p
          className={`text-[11px] text-ink-400 mt-1 ${
            isClickable ? "group-hover:text-accent-300 transition" : ""
          }`}
        >
          {event.detail}
        </p>
      </div>
      {evaluated && (
        <span className="self-start mt-0.5 inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-gain-500/15 text-gain-400 font-medium badge-in">
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          değerlendirildi
        </span>
      )}
    </>
  );

  if (isClickable) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cardClasses + interactive}
        aria-label={`${event.fund ?? event.fonDili} sinyalini incele`}
      >
        {Content}
      </button>
    );
  }
  return <div className={cardClasses}>{Content}</div>;
}
